import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, missionControlService } from '@v2/services';

interface UseSetDefaultMissionControlVersionResult {
  setDefaultVersion: (versionString: string) => Promise<boolean>;
  loading: boolean;
  error: string | null;
}

export function useSetDefaultMissionControlVersion(): UseSetDefaultMissionControlVersionResult {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: missionControlService.setDefaultVersion,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.missionControl.versions.all);
    },
  });

  const setDefaultVersion = async (versionString: string): Promise<boolean> => {
    try {
      await mutation.mutateAsync(versionString);
      return true;
    } catch {
      return false;
    }
  };

  return {
    setDefaultVersion,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
}

export default useSetDefaultMissionControlVersion;
